import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import {
    deleteBike,
    editBike,
    editBikePro,
    getBike,
    getBikeList,
    updateBike,
} from '../sellThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'sellBike';

export const sellBikeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeList });
        handleRequestThunk({ builder, request: getBike });
        handleRequestThunk({ builder, request: deleteBike, isDelete: true });
        handleRequestThunk({ builder, request: editBike });
        handleRequestThunk({ builder, request: editBikePro });
        handleRequestThunk({ builder, request: updateBike });
    },
});

export const sellBike = sellBikeSlice.reducer;
